/*Custom Javascript for hom background*/

/* Start Shape Design by DevWise */

var isHomePage = document.getElementsByClassName('index-sections');
console.log(isHomePage.length);
if (isHomePage.length > 100) {
  //if home page





//shape one
const shapeOne = '#shopify-section-template--23753243459962__16317436332186b499';
const shapeOneSrc = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/8/assets/myshape1.png';
createBgShape(shapeOne,shapeOneSrc);

//shap Two

const shapeTwo = '#shopify-section-template--23753243459962__16317429276ef1a7ec';
const shapeTwoSrc = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/8/assets/myshape2.png';
createBgShape(shapeTwo,shapeTwoSrc);

//shap three

const shapeThree = '#shopify-section-template--23753243459962__1631741491c84e78f7';
const shapeThreeSrc = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/8/assets/myshape1.png';
createBgShape(shapeThree,shapeThreeSrc);

//shap four

const shapeFour = '#shopify-section-template--23753243459962__163174049596e03a04';
const shapeFourSrc = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/8/assets/myshape2.png';
createBgShape(shapeFour,shapeFourSrc);

//shap five

//const shapeFive = '#shopify-section-template--23753243459962__1628690427b49bb805';
//const shapeFiveSrc = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/2/assets/myshape1.png';
//createBgShape(shapeFive,shapeFiveSrc);
  
//ig section shape
const shapeIG = '#shopify-section-template--23753243459962__16322845326ba919a8';
const shapeIGSrc = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/8/assets/myshape1.png';
createBgShape(shapeIG,shapeIGSrc);


  
  
//insert emu icon before title
const featuredTitleOne = '#shopify-section-template--23753243459962__16317429276ef1a7ec .feature-row__text--inner';
const featuredTitleTwo = '#shopify-section-template--23753243459962__16317436332186b499 .feature-row__text--inner';
const featuredTitleThree = '#shopify-section-template--23753243459962__1631741491c84e78f7 .feature-row__text--inner';
const featuredTitleFour = '#shopify-section-template--23753243459962__163174049596e03a04 .feature-row__text--inner';
  
inserImg(featuredTitleOne);
inserImg(featuredTitleTwo);
inserImg(featuredTitleThree);
inserImg(featuredTitleFour);
  
  
  
  
//if home page end
  
  
  
}else{
  //add space on the main ID to fix footer issue.
  
  let devWiseMainBody = document.querySelector('#main');
//  devWiseMainBody.style.marginBottom = '200px';
  
  
  
}
var isLeadPage = document.getElementsByClassName('lead-sections');
console.log(isLeadPage.length);
if (isLeadPage.length > 0) {
  
  const shapeFour = '#shopify-section-template--15304115388599__text-section';
const shapeFourSrc = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/8/assets/myshape2.png';
createBgShape(shapeFour,shapeFourSrc);
  const shapeIG = '#shopify-section-template--15304115388599__form-section';
const shapeIGSrc = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/8/assets/myshape1.png';
createBgShape(shapeIG,shapeIGSrc);
}
var isGoatPage = document.getElementsByClassName('goat-sections');
console.log(isGoatPage.length);
if (isGoatPage.length > 0) {
  
  const shapeFour = '#shopify-section-template--15388158263479__text-section';
const shapeFourSrc = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/8/assets/myshape2.png';
createBgShape(shapeFour,shapeFourSrc);
  const shapeIG = '#shopify-section-template--15388158263479__16589505006f66327c';
const shapeIGSrc = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/8/assets/myshape1.png';
createBgShape(shapeIG,shapeIGSrc);
}
//shap six



//shap product section





//Create Shape and Return
function createBgShape(elementID,imgSrc){
  
  	let element = document.querySelector(elementID);
  	let src     = imgSrc;
  
  	let newDiv = document.createElement('div');
	let shapeImg = document.createElement('img');
  
  	newDiv.classList.add('shape1-div');
  	shapeImg.src = src;
  	newDiv.appendChild(shapeImg);

  	element.appendChild(newDiv);
  
}
function inserImg(elementID){
  
  	let element = document.querySelector(elementID);
  	let src     = 'https://cdn.shopify.com/s/files/1/0600/9221/9575/t/8/assets/go-emu-symbol-02.png';
  
  	
	let imgTag = document.createElement('img');
  
  	imgTag.classList.add('img-before-title');
  	imgTag.src = src;
  	

  	element.prepend(imgTag);
  
}

/* End Shape Design by DevWise */

	var wrapperElement = document.querySelector('body');
	
if(wrapperElement.classList.contains('page-title--contact')){

document.querySelector('#getintouch').addEventListener('click', function (e){
      	e.preventDefault();
		var _klOnsite = window._klOnsite || []; 
		_klOnsite.push(['openForm', 'Uqu5vn']);
	});

}

if(wrapperElement.classList.contains('page-title--contact') || wrapperElement.classList.contains('page-title--wholesale')){

  document.querySelector('#wholesale-button').addEventListener('click', function (e){
    e.preventDefault();
		window._klOnsite = window._klOnsite || []; 
		window._klOnsite.push(['openForm', 'XeY36S']);
	});

}